import { render } from "./Perfil.vue?vue&type=template&id=0f1d9f8b&scoped=true&ts=true"
import script from "./Perfil.vue?vue&type=script&lang=ts"
export * from "./Perfil.vue?vue&type=script&lang=ts"

import "./Perfil.vue?vue&type=style&index=0&id=0f1d9f8b&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1d9f8b"]])

export default __exports__